const {
  SIZE,
  TYPE,
  HIERARCHY,
  BORDER,
  ALIGNMENT,
  SHADOW,
  BACKGROUND,
  MODIFIER,
  SELECTION_TYPE,
  DISPLAY_MODE,
  LOCALE,
  COLOR,
  TRIGGER,
  BUTTON_TYPES,
  SORT,
  CONTENT_TYPE,
  WEIGHT,
} = require('./misc');

const BADGE = {
  COLOR: {
    GRAY: COLOR.GRAY,
    ACCENT: COLOR.ACCENT,
    GREEN: COLOR.GREEN,
    ORANGE: COLOR.ORANGE,
    RED: COLOR.RED,
  },
  TYPE: {
    ERROR: TYPE.ERROR,
    GENERIC: TYPE.GENERIC,
    NEUTRAL: TYPE.NEUTRAL,
    SUCCESS: TYPE.SUCCESS,
    WARNING: TYPE.WARNING,
  },
  SIZE: {
    SMALL: SIZE.SMALL,
    LARGE: SIZE.LARGE,
  },
  HIERARCHY: {
    LOUD: HIERARCHY.LOUD,
    QUIET: HIERARCHY.QUIET,
  },
  BORDERS: {
    STANDARD: BORDER.STANDARD,
    ROUNDED: BORDER.ROUNDED,
    CORNER: BORDER.CORNER,
  },
  CONTENT_TYPE: {
    ICON: CONTENT_TYPE.ICON,
    TEXT: CONTENT_TYPE.TEXT,
  },
  ROUNDED_CORNERS: {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
  },
};

const BOTTOM_SHEET = {
  TITLE_ALIGN: {
    CENTER: ALIGNMENT.CENTER,
    LEFT: ALIGNMENT.LEFT,
  },
};

const BUTTON = {
  HIERARCHY: { ...HIERARCHY },
  TYPES: { ...BUTTON_TYPES },
  SIZE: {
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
  },
  SIDE: {
    TOP: ALIGNMENT.TOP,
    BOTTOM: ALIGNMENT.BOTTOM,
    LEFT_TOP: ALIGNMENT.LEFT_TOP,
    RIGHT_TOP: ALIGNMENT.RIGHT_TOP,
    BOTTOM_RIGHT: ALIGNMENT.BOTTOM_RIGHT,
    BOTTOM_LEFT: ALIGNMENT.BOTTOM_LEFT,
    TOP_LEFT: ALIGNMENT.TOP_LEFT,
    TOP_RIGHT: ALIGNMENT.TOP_RIGHT,
  },
};

const CARD = {
  SHADOW: {
    FLAT: SHADOW.FLAT,
    ELEVATED: SHADOW.ELEVATED,
    OUTLINE: SHADOW.OUTLINE,
  },
  BORDER_COLOR: {
    DEFAULT: TYPE.DEFAULT,
    ERROR: TYPE.ERROR,
    WARNING: TYPE.WARNING,
    SUCCESS: TYPE.SUCCESS,
    NEUTRAL: TYPE.NEUTRAL,
    ACCENT: COLOR.ACCENT,
    GREEN: COLOR.GREEN,
    ORANGE: COLOR.ORANGE,
    RED: COLOR.RED,
  },
  BACKGROUND: {
    LIGHT: BACKGROUND.LIGHT,
    DARK: BACKGROUND.DARK,
  },
  PADDING_SIZE: {
    ZERO: 0,
    SIXTEEN: 16,
    TWENTY_FOUR: 24,
    THIRTY_TWO: 32,
    FOURTY: 40,
  },
};

const CHECKBOX_LIST = {
  SIDE: {
    LEFT: ALIGNMENT.LEFT,
    RIGHT: ALIGNMENT.RIGHT,
  },
};

const CHECKBOX = {
  TYPE: {
    DEFAULT: TYPE.DEFAULT,
    INDETERMINATE: TYPE.INDETERMINATE,
    EMBEDDED: TYPE.EMBEDDED,
  },
  MODIFIER: {
    DEFAULT: TYPE.DEFAULT,
    ERROR: TYPE.ERROR,
  },
  LABEL_POSITION: {
    LEFT: ALIGNMENT.LEFT,
    RIGHT: ALIGNMENT.RIGHT,
  },
};

const DATEPICKER = {
  SELECTION_TYPE: {
    RANGE: SELECTION_TYPE.RANGE,
    SINGLE: SELECTION_TYPE.SINGLE,
    MULTIPLE: SELECTION_TYPE.MULTIPLE,
  },
  DISPLAY_MODE: {
    INLINE: DISPLAY_MODE.INLINE,
    INPUT: DISPLAY_MODE.INPUT,
  },
  LOCALE: {
    ENGLISH: LOCALE.ENGLISH,
    SPANISH: LOCALE.SPANISH,
    PORTUGUESE: LOCALE.PORTUGUESE,
  },
};

const DROPDOWN = {
  TYPE: {
    FORM: DISPLAY_MODE.FORM,
    STANDALONE: DISPLAY_MODE.STANDALONE,
  },
  SIZE: {
    DEFAULT: TYPE.DEFAULT,
    COMPACT: DISPLAY_MODE.COMPACT,
  },
  MODIFIER: {
    ERROR: MODIFIER.ERROR,
    READONLY: MODIFIER.READONLY,
  },
  MENU_ALIGNMENT: {
    CENTER: ALIGNMENT.CENTER,
    BOTTOM: ALIGNMENT.BOTTOM,
  },
  WIDTH: {
    TWENTY_FIVE: 25,
    FIFTY: 50,
    SEVENTY_FIVE: 75,
    ONE_HUNDRED: 100,
    ONE_HUNDRED_FIFTY: 150,
    TWO_HUNDRED: 200,
  },
};

const INLINE_EDIT = {
  ICON_SIZE: {
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
  },
  BEHAVIOUR: {
    DEFAULT: TYPE.DEFAULT,
    MAXED: DISPLAY_MODE.MAXED,
  },
};

const LIST = {
  TYPE: {
    DEFAULT: TYPE.DEFAULT,
    DROPDOWN: DISPLAY_MODE.DROPDOWN,
  },
  size: { ...DROPDOWN.SIZE },
};

const LIST_ITEM = {
  TERTIARY_POSITION: {
    TOP: ALIGNMENT.TOP,
    CENTER: ALIGNMENT.CENTERED,
  },
  SIZE: {
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
  },
  PADDING_SIZE: {
    ZERO: '0',
    SIXTEEN: '16',
    TWENTY_FOUR: '24',
    THIRTY_TWO: '32',
    FOURTY: '40',
  },
  HEIGHT_ROW: {
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
  },
  CHEVRON_POSITION: {
    TOP: ALIGNMENT.TOP,
    CENTERED: ALIGNMENT.CENTERED,
  },
  RIGHT_CONTENT_POSITION: {
    TOP: ALIGNMENT.TOP,
    CENTERED: ALIGNMENT.CENTERED,
  },
  TARGET: {
    SELF: '_self',
    BLANK: '_blank',
    PARENT: '_parent',
    TOP: '_top',
  },
};

const LIST_GROUP = {
  SIZE: {
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
  },
  PADDING_SIZE: {
    ZERO: '0',
    SIXTEEN: '16',
    TWENTY_FOUR: '24',
    THIRTY_TWO: '32',
    FOURTY: '40',
  },
};

const LIST_BOX = {
  SELECTION_MODE: {
    SINGLE: SELECTION_TYPE.SINGLE,
    MULTIPLE: SELECTION_TYPE.MULTIPLE,
  },
};

const MESSAGE = {
  ACTION_POSITION: {
    RIGHT: ALIGNMENT.RIGHT,
    BOTTOM: ALIGNMENT.BOTTOM,
  },
  TYPE: {
    NEUTRAL: TYPE.NEUTRAL,
    SUCCESS: TYPE.SUCCESS,
    WARNING: TYPE.WARNING,
    ERROR: TYPE.ERROR,
  },
  HIERARCHY: {
    LOUD: HIERARCHY.LOUD,
    QUIET: HIERARCHY.QUIET,
  },
  COLOR: {
    ACCENT: COLOR.ACCENT,
    GREEN: COLOR.GREEN,
    ORANGE: COLOR.ORANGE,
    RED: COLOR.RED,
  },
};

const MODAL = {
  TYPE: {
    SMALL: SIZE.SMALL,
    LARGE: SIZE.LARGE,
    FULL: TYPE.FULL,
    CARD: TYPE.CARD,
  },
};

const PROGRESS_INDICATOR_CIRCULAR = {
  TYPE: {
    DETERMINATE: TYPE.DETERMINATE,
    INDETERMINATE: TYPE.INDETERMINATE,
  },
  SIZE: {
    XSMALL: SIZE.XSMALL,
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
    XLARGE: SIZE.XLARGE,
  },
  COLOR: {
    BLUE: COLOR.BLUE,
    WHITE: COLOR.WHITE,
  },
  MODIFIER: {
    BLOCK: MODIFIER.BLOCK,
    FULLSCREEN: MODIFIER.FULLSCREEN,
    INLINE: MODIFIER.INLINE,
  },
};

const SLIDER = {
  TYPES: {
    SINGLE: TYPE.SINGLE,
    RANGE: SELECTION_TYPE.RANGE,
  },
};

const SPINNER = {
  MODIFIER: {
    INLINE: MODIFIER.INLINE,
    BLOCK: MODIFIER.BLOCK,
    FULLSCREEN: MODIFIER.FULLSCREEN,
  },
  SIZE: {
    XXSMALL: SIZE.XXSMALL,
    XSMALL: SIZE.XSMALL,
    SMALL: SIZE.SMALL,
    MEDIUM: SIZE.MEDIUM,
    LARGE: SIZE.LARGE,
  },
};

const RADIO_BUTTON = {
  MODIFIER: {
    DEFAULT: TYPE.DEFAULT,
    ERROR: TYPE.ERROR,
  },
};

const SNACKBAR = {
  TYPE: {
    DEFAULT: TYPE.DEFAULT,
    SUCCESS: TYPE.SUCCESS,
    ERROR: TYPE.ERROR,
  },
  ACTION_POSITION: {
    RIGHT: ALIGNMENT.RIGHT,
    BOTTOM: ALIGNMENT.BOTTOM,
  },
  COLOR: {
    GREEN: COLOR.GREEN,
    RED: COLOR.RED,
  },
};

const TABLE = {
  SORT: {
    ASCENDANT: SORT.ASCENDANT,
    DESCENDANT: SORT.DESCENDANT,
  },
  ALIGN: {
    LEFT: ALIGNMENT.LEFT,
    CENTER: ALIGNMENT.CENTER,
    RIGHT: ALIGNMENT.RIGHT,
  },
};

const TAG = {
  SIZE: {
    SMALL: SIZE.SMALL,
    LARGE: SIZE.LARGE,
  },
  COLOR: {
    DEFAULT: TYPE.DEFAULT,
    ACCENT: COLOR.ACCENT,
    ERROR: TYPE.ERROR,
    SUCCESS: TYPE.SUCCESS,
    WARNING: TYPE.WARNING,
    GREEN: COLOR.GREEN,
    ORANGE: COLOR.ORANGE,
    RED: COLOR.RED,
  },
};

const TEXTFIELD = {
  MODIFIER: {
    DEFAULT: TYPE.DEFAULT,
    ERROR: TYPE.ERROR,
    COMPLETED: MODIFIER.COMPLETED,
    INDETERMINATE: TYPE.INDETERMINATE,
    READONLY: MODIFIER.READONLY,
  },
  SPLIT_POSITION: {
    LEFT: ALIGNMENT.LEFT,
    RIGHT: ALIGNMENT.RIGHT,
  },
};

const THUMBNAIL = {
  MODIFIER: {
    CIRCLE: MODIFIER.CIRCLE,
    SQUARE: MODIFIER.SQUARE,
  },
  HIERARCHY: {
    DEFAULT: HIERARCHY.DEFAULT,
    LOUD: HIERARCHY.LOUD,
    QUIET: HIERARCHY.QUIET,
  },
  TYPE: {
    GRID: 'grid',
    STACKED: 'stacked',
  },
  SIZE: {
    TWENTY_FOUR: 24,
    THIRTY_TWO: 32,
    FOURTY: 40,
    FORTY_EIGHT: 48,
    FIFTY_SIX: 56,
    SIXTY_FOUR: 64,
    SEVENTY_TWO: 72,
    EIGHTY: 80,
  },
};

const TOOLTIP = {
  SIDE: {
    TOP: ALIGNMENT.TOP,
    BOTTOM: ALIGNMENT.BOTTOM,
    LEFT_TOP: ALIGNMENT.LEFT_TOP,
    RIGHT_TOP: ALIGNMENT.RIGHT_TOP,
    BOTTOM_RIGHT: ALIGNMENT.BOTTOM_RIGHT,
    BOTTOM_LEFT: ALIGNMENT.BOTTOM_LEFT,
    TOP_LEFT: ALIGNMENT.TOP_LEFT,
    TOP_RIGHT: ALIGNMENT.TOP_RIGHT,
    LEFT: ALIGNMENT.LEFT,
    RIGHT: ALIGNMENT.RIGHT,
  },
  TRIGGER: {
    HOVER: TRIGGER.HOVER,
    CLICK: TRIGGER.CLICK,
    NO_TRIGGER: TRIGGER.NO_TRIGGER,
  },
  TYPE: {
    LIGHT: BACKGROUND.LIGHT,
    DARK: BACKGROUND.DARK,
    HIGHLIGHT: TYPE.HIGHLIGHT,
  },
};

const TYPOGRAPHY = {
  COMPONENT: {
    SPAN: 'span',
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    P: 'p',
    A: 'a',
  },
  SIZE: {
    XS: 'xs',
    S: 's',
    M: 'm',
    L: 'l',
    XL: 'xl',
  },
  COLOR: {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    DISABLED: 'disabled',
    INVERTED: 'inverted',
    LINK: 'link',
    NEGATIVE: 'negative',
    CAUTION: 'caution',
    POSITIVE: 'positive',
  },
  TYPE: {
    BODY: 'body',
    TITLE: 'title',
  },
  WEIGHT: {
    REGULAR: WEIGHT.REGULAR,
    SEMIBOLD: WEIGHT.SEMIBOLD,
  },
};

const MONEY_AMOUNT = {
  TYPE: {
    DEFAULT: 'default',
    CRYPTO: 'crypto',
  },
  CENTS_TYPE: {
    SUPERSCRIPT: 'superscript',
    COMMA: 'comma',
    DOT: 'dot',
  },
  WEIGHT: {
    REGULAR: WEIGHT.REGULAR,
    SEMIBOLD: WEIGHT.SEMIBOLD,
  },
  SIZE: {
    TWELVE: 12,
    FOURTEEN: 14,
    SIXTEEN: 16,
    EIGHTEEN: 18,
    TWENTY: 20,
    TWENTY_FOUR: 24,
    TWENTY_EIGHT: 28,
    THIRTY_TWO: 32,
    THIRTY_SIX: 36,
    FOURTY: 40,
    FORTY_FOUR: 44,
    FORTY_EIGHT: 48,
    FIFTY_TWO: 52,
    FIFTY_SIX: 56,
    SIXTY: 60,
  },
};

const FEEDBACK_SCREEN = {
  TYPE: {
    SIMPLE: 'simple',
    CONGRATS: 'congrats',
  },
  COLOR: {
    GREEN: 'green',
    ORANGE: 'orange',
    RED: 'red',
  },
};

const CAROUSEL = {
  TYPE: {
    CONTENT: 'content',
    FULL: 'full',
  },
  SPACING: {
    ZERO: 0,
    TWELVE: 12,
    SIXTEEN: 16,
    TWENTY_FOUR: 24,
  },
  ARROW_SIZE: {
    SMALL: SIZE.SMALL,
    LARGE: SIZE.LARGE,
  },
  PAGINATION_MODE: {
    LIGHT: BACKGROUND.LIGHT,
    DARK: BACKGROUND.DARK,
  },
  PAGINATION_POSITION: {
    TOP: ALIGNMENT.TOP,
    BOTTOM: ALIGNMENT.BOTTOM,
  },
  SCROLL: {
    HIDDEN: 'hidden',
    VISIBLE: 'visible',
  },
};

const FILE_UPLOADER = {
  TYPE: {
    TAG: 'tag',
    THUMBNAIL: 'thumbnail',
  },
  DISPLAY: {
    CAROUSEL: 'carousel',
    GALLERY: 'gallery',
  },
};

const FLOATING_MENU = {
  TYPE: {
    SELECT: 'select',
    MENU: 'menu',
  },
  PLACEMENT: {
    TOP: ALIGNMENT.TOP,
    BOTTOM: ALIGNMENT.BOTTOM,
    LEFT: ALIGNMENT.LEFT,
    RIGHT: ALIGNMENT.RIGHT,
    BOTTOM_START: 'bottom-start',
    BOTTOM_END: 'bottom-end',
    TOP_START: 'top-start',
    TOP_END: 'top-end',
    LEFT_START: 'left-start',
    LEFT_END: 'left-end',
    RIGHT_START: 'right-start',
    RIGHT_END: 'right-end',
  },
};

const PROGRESS_INDICATOR_LINEAR = {
  SIZE: {
    SMALL: SIZE.SMALL,
    LARGE: SIZE.LARGE,
  },
};

module.exports = {
  BADGE,
  BOTTOM_SHEET,
  BUTTON,
  CARD,
  CHECKBOX_LIST,
  DATEPICKER,
  INLINE_EDIT,
  DROPDOWN,
  LIST,
  LIST_ITEM,
  LIST_GROUP,
  LIST_BOX,
  MESSAGE,
  MODAL,
  PROGRESS_INDICATOR_CIRCULAR,
  SPINNER,
  CHECKBOX,
  SLIDER,
  TABLE,
  TAG,
  TEXTFIELD,
  THUMBNAIL,
  TOOLTIP,
  RADIO_BUTTON,
  SNACKBAR,
  TYPOGRAPHY,
  MONEY_AMOUNT,
  FEEDBACK_SCREEN,
  CAROUSEL,
  FILE_UPLOADER,
  FLOATING_MENU,
  PROGRESS_INDICATOR_LINEAR,
};
